// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"a2e2fc0b","921":"7325b938"}[chunkId] + ".chunk.js";
};